// The V2 backend memoizes its Hyperliquid reads for a couple of seconds (the per-coin and all-positions hooks poll the
// same account). Anything that knows the account just changed (a write the backend made, a fill or a clearinghouse
// push the V2 trade notifications saw) bumps this epoch first, so the refetch it triggers reads fresh data instead of
// the memo. Engine-free on purpose: the notification hook imports it from the V1 bundle.

const epochs = new Map<string, number>();

/** The read epoch of `address`: a memo taken at an older epoch is stale. */
export function v2ReadEpoch(address: string): number {
    return epochs.get(address.toLowerCase()) ?? 0;
}

/** Marks every memoized read of `address` stale. */
export function bumpV2ReadEpoch(address: string): void {
    const key = address.toLowerCase();
    epochs.set(key, (epochs.get(key) ?? 0) + 1);
}
